import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import Helmet from 'react-helmet'

import StandardWrapper from '../components/standardWrapper'
import constructionImage from '../images/constructionSign.png'

const ConstructionSign = styled.div`
  height: 500px;
  width: 500px;
  background-image: url(${constructionImage});
  background-size: contain;
  background-repeat: no-repeat;
`

const IndexPage = () => (
  <StandardWrapper>
    <Helmet
      title="Birkenstab"
      meta={[
        { name: 'keywords', content: 'birkenstab, birkenstab.de, homepage, personal website, website' }
      ]}
    />
    <h1>Hello I'm Birkenstab</h1>
    <p>This is my awesome website</p>
    <p>It is still far from finished. The <Link to="/stuff">Stuff page</Link> is the only one with content right now</p>
    <Link to="/stuff">Go to Stuff</Link>
    <ConstructionSign title="construction sign" />
    <figcaption>I drew this picture in 2010 :D</figcaption>
  </StandardWrapper>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js